"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var MTCaptcha = function MTCaptcha(_ref) {
  var setFieldValue = _ref.setFieldValue,
    siteKey = _ref.siteKey,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? '' : _ref$action;
  window.verified = function (e) {
    setFieldValue('captcha', e.verifiedToken);
  };
  window.verifyExpired = function () {
    setFieldValue('captcha', '');
  };
  (0, _react.useEffect)(function () {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.innerHTML = "var mtcaptchaConfig = {\n        \"sitekey\": \"".concat(siteKey, "\",\n        \"verified-callback\": verified,\n        \"verifyexpired-callback\": verifyExpired,\n        \"action\": \"").concat(action, "\",\n        \"lang\": \"de\",\n        \"customLangText\": {\n          \"de\": {\n                \"inputPrompt\": \"Geben Sie den Text ein.\"\n               }\n         }\n    };");
    document.body.appendChild(s);
    var mt_service = document.createElement('script');
    mt_service.src = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
    mt_service.async = true;
    document.body.appendChild(mt_service);
    var mt_service2 = document.createElement('script');
    mt_service2.src = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';
    mt_service2.async = true;
    document.body.appendChild(mt_service2);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mtcaptcha"
  });
};
var _default = exports.default = MTCaptcha;